export { default } from './QuotationEdit'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Quotation/QuotationEdit/index.js